import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useSearchParams,
} from "react-router-dom";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Scorecard from "@/pages/Scorecard";
import Check from "@/pages/Check";
import { Audiences, Insights, About } from "@/pages/Content";
import { AudienceDetail, InsightDetail } from "@/pages/Detail";
import { ContentProvider, useContent } from "@/content/ContentProvider";
import { ArticleCategory, ManagedPage } from "@/pages/Managed";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/Privacy";
import Booked from "@/pages/Booked";
import Audit from "@/pages/Audit";
import AuditSample from "@/pages/AuditSample";
import AuditPreview from "@/pages/AuditPreview";
import Pricing from "@/pages/Pricing";
import Room from "@/pages/Room";
import Client from "@/pages/Client";
import Paid from "@/pages/Paid";
import Book from "@/pages/Book";
import Private from "@/pages/Private";

// The first step: the check in the new layout, the scorecard for live visitors until publish.
function FirstStep() {
  const { nextLayout } = useContent();
  return nextLayout ? <Check /> : <Scorecard />;
}

// Categories, notes and services are parked: they open only through a draft preview link.
function Parked({ children }) {
  const [params] = useSearchParams();
  return params.get("preview") ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ContentProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route
                path="/services"
                element={
                  <Parked>
                    <Services />
                  </Parked>
                }
              />
              <Route
                path="/for"
                element={
                  <Parked>
                    <Audiences />
                  </Parked>
                }
              />
              <Route
                path="/for/:slug"
                element={
                  <Parked>
                    <AudienceDetail />
                  </Parked>
                }
              />
              <Route path="/cases" element={<Navigate to="/" replace />} />
              <Route path="/cases/:id" element={<Navigate to="/" replace />} />
              <Route
                path="/insights"
                element={
                  <Parked>
                    <Insights />
                  </Parked>
                }
              />
              <Route
                path="/insights/category/:slug"
                element={
                  <Parked>
                    <ArticleCategory />
                  </Parked>
                }
              />
              <Route path="/pages/:slug" element={<ManagedPage />} />
              <Route
                path="/insights/:id"
                element={
                  <Parked>
                    <InsightDetail />
                  </Parked>
                }
              />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Navigate to="/about" replace />} />
              <Route path="/scorecard" element={<FirstStep />} />
              <Route
                path="/scorecard/:vertical"
                element={<Navigate to="/scorecard" replace />}
              />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/booked" element={<Booked />} />
              <Route path="/paid" element={<Paid />} />
              <Route path="/book" element={<Book />} />
              <Route path="/audit" element={<Audit />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/a/:slug" element={<Room />} />
              <Route path="/p/:slug" element={<Private />} />
              <Route path="/client" element={<Client />} />
              <Route path="/audit/sample" element={<AuditSample />} />
              <Route path="/audit/preview" element={<AuditPreview />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </ContentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
